import { Button, Flex, Paper, Text, Loader, TextInput } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../hooks";
import { RootState } from "../store";
import { displayServerErrorMessage } from "../shared/ErrorMessage";
import { initialize, updateField } from "../slices/form/deleteVent";
import { useEffect } from "react";
import {
  DeleteVentRequest,
  useDeleteVentMutation,
} from "../slices/api/ventsApi";
import dayjs from "dayjs";
import { setConsoleIds } from "./Console";

interface Props {
  ventId: string;
  ventName: string;
  ventEnds: string;
  updateTime: string;
  onClose: () => void;
}
const DeleteVent = (props: Props) => {
  const { data, hasChanges } = useAppSelector(
    (state: RootState) => state.deleteVentForm
  );
  const [deleteVent] = useDeleteVentMutation();

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(
      initialize({
        confirm: "",
      })
    );
  }, []);

  const handleDelete = async (ventId: string) => {
    if (ventId === undefined) {
      console.error("ventId is undefined but should not be");
      return;
    }

    const request: DeleteVentRequest = {
      ventId: ventId,
    };

    try {
      await deleteVent(request).unwrap();
      setConsoleIds({ ventId: null });
      props.onClose();
    } catch (error) {
      displayServerErrorMessage(error);
    }
  };

  if (!data) {
    return <Loader color="blue" />;
  }

  const canDelete = dayjs().isAfter(dayjs(props.ventEnds));

  return (
    <>
      <Paper>
        <Text size="lg">{`Delete ${props.ventName}`}</Text>
        {!canDelete && (
          <Text mt="lg">
            You cannot delete this event because it has not ended. To delete it,
            first set the end time to be earlier than the current time.
          </Text>
        )}
        {canDelete && (
          <>
            <Text size="lg">
              To delete this event, first type the word DELETE in the box below.
              This will permanently delete the event, along with all of the
              guests and activities. This action cannot be undone.
            </Text>
            <TextInput
              required
              mt="md"
              label="Confirm"
              style={{ width: "300px" }}
              value={data.confirm ?? ""}
              onChange={(v) => {
                dispatch(
                  updateField({
                    field: "confirm",
                    value: v.currentTarget.value,
                  })
                );
              }}
            />
          </>
        )}
        <Flex justify="flex-end">
          <Button mt="md" mr="md" onClick={props.onClose}>
            Cancel
          </Button>
          <Button
            mt="md"
            onClick={() => handleDelete(props.ventId)}
            disabled={!hasChanges || data.confirm !== "DELETE"}
          >
            Delete
          </Button>
        </Flex>
      </Paper>
    </>
  );
};

export default DeleteVent;
